module.exports = __webpack_public_path__ + "static/media/pagaSvg.0521cb2c.svg";